import Accordion, { Color } from "../accordion"
import { Episode } from "../../apiStrapi/models/contentType/courses";
import PartialLogin, { TypePartial } from "../partialLogin";
import { useState } from "react";

export interface CourseDetailEpisode {
  totalHours: string,
  totalEpisodes: string,
  episodes: Episode[],
  annualPromotion?
}

export default function EpisodeAccordion({ totalHours, totalEpisodes, episodes,annualPromotion }: CourseDetailEpisode) {
  const localEpisodes = episodes ? episodes.sort((a, b) => { return a.episode_number - b.episode_number }) : [{} as Episode];
  const [showAccordion, setShowAccordion] = useState<boolean>(true);
  
  async function setClikedAccor(index: number) {
    setShowAccordion(false);
    await episodes.map(async (eachEpisode, eachIndex) => {
      eachEpisode.showDetails = eachIndex === index && !eachEpisode.showDetails;
    });
    setShowAccordion(true);
  }

  return (
    <div className="background-dark">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="block-type-text text-left col-12">
            <div className="row block box-shadow-none justify-content-center">
              <h1 className="lg-mr-space row justify-content-center">
                <strong>
                  <span className="color-smooth">
                    ⌛ {totalHours?.toString().replace('.', ':')} ชั่วโมง
                  </span>
                </strong>
              </h1>
              <h1 className="row justify-content-center">
                <strong>
                  <span className="color-smooth">
                    📚 {totalEpisodes} บทเรียน
                  </span>
                </strong>
              </h1>
            </div>
            <div className="block box-shadow-none">
              <div className="feature column-center">
                <div className='row p-w-100 justify-content-center'>
                  <PartialLogin
                      checkout_url={annualPromotion.data?.attributes?.checkout_url}
                      type={TypePartial.AnnualSubscription}
                      render={
                        <a className="btn btn-long-one m-l-20">
                          <i className="far fa-shopping-cart f-s-14 m-r-5"/>
                          <span className="f-s-14">ซื้อแพ็กเกจรายปี</span>
                        </a>
                      }
                    />
                    <PartialLogin
                      checkout_url={"/free-trial"}
                      type={TypePartial.None}
                      render={
                        <a className="btn btn-long-one btn-black-outlet m-l-20">
                          <i className="fal fa-megaphone f-s-14 m-r-5" />
                          <span className="f-s-14">ทดลองเรียนฟรี</span>
                        </a>
                      }
                    />
                </div>
              </div>
            </div>
          </div>
          <div className="grid-container">
            {localEpisodes && localEpisodes.map((value, index) => {
              if (!value.episode_name?.toLocaleLowerCase().includes("teaser")) {
                return (
                  <Accordion
                    key={index}
                    title={value.episode_name}
                    clickFunction={() => setClikedAccor(index)}
                    description={value.description}
                    col={12}
                    color={Color.dark}
                    showDetails={value.showDetails}
                  />
                )
              }
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
